export default __webpack_public_path__ + "static/poster-71e9dd864201328abf6e076983460417.jpg";